import { render, staticRenderFns } from "./BootstrapNotification.vue?vue&type=template&id=39c4394d&"
import script from "./BootstrapNotification.vue?vue&type=script&lang=js&"
export * from "./BootstrapNotification.vue?vue&type=script&lang=js&"
import style0 from "./BootstrapNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports